import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import { TextInput } from '../Helpers/Inputs';
import { object, string } from 'yup';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import Button from '@material-ui/core/Button';
import { emptyStringToUndefined } from '../Helpers/Formatters/EmptyStringToUndefined.js';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem, SESSION_STORAGE_AFLAC_QUOTE } from '../../sessionStorage';

export default function RetrieveProgress(props) {
  const { register, errors, handleSubmit, setValue } = useForm({
    validationSchema: RetrieveProgress.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur'
  });

  const [email, setEmail] = useState('');
  const [pin, setPin] = useState('');
  const SESSION_STORAGE_KEY = 'AMERICO_QUOTE';
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleEmailChange = value => {
    setValue('email', value);
    setEmail(value);
  };

  const handlePinChange = value => {
    setValue('pin', value);
    setPin(value);
  };

  useEffect(() => {
    register({ name: 'email' });
    setValue('email', email);
    register({ name: 'pin' });
    setValue('pin', pin);
  }, []);

  const onNext = () => {
    setLoading(true);
    setMessage('');

    let appId = new URLSearchParams(window.location.search).get('appId');

    fetch('api/ConsumerApplication/Get?email=' + encodeURIComponent(email) + '&pin=' + pin + '&appId=' + appId, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId,
      }
    })
      .then(res => res.json())
      .then(data => {
        if (data.appData !== null && data.appData.includes('currentStep')) {
          if (data.productType === "Supplemental Health") {
            sessionStorage.setItem(SESSION_STORAGE_AFLAC_QUOTE, data.appData);
            props.history.push(`/quote/aflac/hospital-confinement/`);
          }
          else {
            sessionStorage.setItem(SESSION_STORAGE_KEY, data.appData);
            if (JSON.parse(data.appData).isAmerico3 === true) {
              props.history.push(`/loan-protection/`);
            } else {
              props.history.push(`/quote/term-life-insurance/loan-protector/`);
            }
          }

        } else {
          setMessage('No progress was found for that Email and PIN.');
        }
        setLoading(false);
      });
  };

  return (
    <Container>
      <Row className="formPage justify-content-center">
        <Col lg={6}>
          <Form onSubmit={handleSubmit(onNext)}>
            <br />
            <br />
            <h3>Retrieve Progress</h3>
            Enter the email and PIN set on a prior application to retrieve progress.<br />
            <br />
            <TextInput
              id="email"
              name="email"
              label="Email Address"
              value={email}
              onChange={e => handleEmailChange(e.target.value)}
              errors={errors.email}
              inputRef={register}
            />
            <br />
            <br />
            <TextInput
              id="pin"
              type="password"
              name="pin"
              label="4 Digit PIN"
              value={pin}
              onChange={e => handlePinChange(e.target.value)}
              errors={errors.pin}
              inputRef={register}
              inputProps={{
                maxLength: 4
              }}
            />
            <br />
            <br />
            <Button disabled={loading} type="submit" variant="contained" color="primary">
              Continue
            </Button>
            <br />
            <br />
            {message}
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
          </Form>
        </Col>
      </Row>
    </Container>
  );
}

RetrieveProgress.ValidationSchema = object().shape({
  email: string()
    .transform(emptyStringToUndefined)
    .email('Invalid email')
    .required('Email is required'),
  pin: string()
    .transform(emptyStringToUndefined)
    .required('PIN is required')
    .length(4)
    .matches(/\d{4}/, 'PIN must be 4 numeric digits')
});

RetrieveProgress.DefaultFormState = {
  email: '',
  pin: ''
};



// WEBPACK FOOTER //
// ./src/components/General/RetrieveProgress.js